<template>
    <SwitchGroup as="div" class="flex items-center">
        <Switch v-model="proxyChecked" :class="[checked ? 'bg-primary' : 'bg-gray-200', 'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary']">
            <span aria-hidden="true" :class="[checked ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200']" />
        </Switch>
        <SwitchLabel as="span" class="ml-3">
            <span class="text-sm font-medium text-gray-900">{{ label }}</span>
        </SwitchLabel>
    </SwitchGroup>
</template>

<script>
import { Switch, SwitchGroup, SwitchLabel } from '@headlessui/vue'

export default {
    components: {
        Switch,
        SwitchGroup,
        SwitchLabel,
    },
    emits: ['update:checked'],

    props: {
        label: {
            type: String,
            default: '',
        },
        checked: {
            type: [Array, Boolean],
            default: false,
        },
    },

    computed: {
        proxyChecked: {
            get() {
                return this.checked;
            },

            set(val) {
                this.$emit("update:checked", val);
            },
        },
    },
}
</script>
